import React from 'react';
import { ScheduleSRPortal } from '../ScheduleSRPortal';
import {
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
  envUrlSRPortal,
  routes,
} from '../../config';
import cookieService from '../../services/cookieService';
import providerService from '../../services/providerService';

const SRPortalHome = () => {
  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails();
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;

  // Configure SR Portal remote module
  // Note: The remote exposes SRPortalApp with Pages enum via Module Federation
  const srPortalConfig = {
    enabled: true,
    scheduleSRPortalScriptPath: `${envUrlSRPortal}/static/chunks/remoteEntry.js`,
    apiBaseUrl: envUrlSRPortal,
  };

  return (
    <>
      <ScheduleSRPortal
        config={srPortalConfig}
        accessToken={accessToken}
        idToken={idToken}
        selectedProviderId={providerId}
        pageType="Home"
        logoutUrl={logoutUrl}
      />
    </>
  );
};

export default SRPortalHome;
